'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, use } from 'react';
import UserAllWorlds from '@/app/[locale]/(worlds)/profile/components/UserAllWorlds';
import UserFeaturedRooms from '@/app/[locale]/(worlds)/profile/components/UserFeaturedRooms';
import UserFeaturedRoomsSkeleton from '@/app/[locale]/(worlds)/profile/components/UserFeaturedRoomsSkeleton';
import { useOwnerProfileContext } from '@/context/OwnerProfileContext';
const MAX_FEATURED_ROOMS = 3;
function UserFeaturedRoomsHeaderContent() {
  const $ = _c(7);
  const {
    featuredRoomsPromise
  } = useOwnerProfileContext();
  const featuredRooms = use(featuredRoomsPromise);
  const stopSetAsFeatured = featuredRooms.length >= MAX_FEATURED_ROOMS;
  let t0;
  if ($[0] !== featuredRooms) {
    t0 = <UserFeaturedRooms featuredRooms={featuredRooms} />;
    $[0] = featuredRooms;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== stopSetAsFeatured) {
    t1 = <UserAllWorlds stopSetAsFeatured={stopSetAsFeatured} />;
    $[2] = stopSetAsFeatured;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export default function UserFeaturedRoomsHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<UserFeaturedRoomsSkeleton />}><UserFeaturedRoomsHeaderContent /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}